export default {
  education: {
    webinar: {
      title: "Regístrese para el evento para acceder a la grabación",
      text: "Puede iniciar sesión automáticamente con los datos de su cuenta actual o ingresar los datos manualmente en el siguiente paso.",
      label: "Al registrarse, usted acepta",
      link: "términos de transferencia al socio de servicio MTS Link",
      close: "Ingrese los datos manualmente",
      submit: "Registrarse",
    },
    metaTitle: "Educación",
    noContentLang: "No hay materiales publicados en esta lengua todavía",
    titles: {
      material: "Formación para médicos",
      course: "Cursos educativos para médicos",
      simulator: "Simuladores para médicos",
      webinar: "Webinarios para médicos",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Tipo de materiales",
        },
        lang: {
          placeholder: "Idioma",
        },
        status: {
          placeholder: "Estado",
          values: {
            actual: "Actuales",
            overpast: "Pasados",
          },
        },
        specialty: {
          placeholder: "Especialidad",
        },
      },
      tabs: {
        material: "Todos los materiales",
        course: "Cursos",
        simulator: "Simuladores",
        webinar: "Webinarios",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Tus materiales",
          course: "Tus cursos",
          simulator: "Tus simuladores",
          webinar: "Tus webinarios",
        },
        recomended: {
          material: "Materiales recomendados",
          course: "Cursos recomendados",
          simulator: "Simuladores recomendados",
          webinar: "Webinarios recomendados",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Lección",
      Files: "Archivos adjuntos",
      DownloadAll: "Descargar todo",
    },
    status: {
      success: "Completado",
      unsuccess: "No completado",
      stop: "No disponible",
    },
  },
  Tests: {
    table: {
      tests: "Pruebas",
      description: "Descripción",
      points: "Puntos",
      status: "Estado",
    },
    modal: {
      title: "¿Quieres finalizar la prueba?",
    },
    questions: {
      question: "Pregunta",
      answer: "Respuesta",
      correct: "Correcto",
      incorrect: "Incorrecto",
      moderated: "En revisión",
      navigation: "Navegación del test",
      enterAnswer: "Ingrese la respuesta...",
    },
    errors: {
      required: "Pregunta obligatoria",
    },
    submit: "Finalizar prueba",
    result: "Resultado",
    repeat: "Repetir",
  },
  afterPayCourse: {
    title: "Has adquirido con éxito el curso",
    text: "Ahora tiene acceso a los materiales de capacitación",
    buttonText: "Ir al curso",
  },
  coursePage: {
    courseType: {
      course: "Cursos",
      simulator: "Maqueta de entrenamiento",
      webinar: "Webinar",
    },
    groupNumber: "{n}-ésimo flujo",
    manager: "Gerente",
    curator: "Curador",
    free: "Gratis",
  },
  coursesPage: {
    materials: "Materiales",
    schools: "Escuelas de autor",
    universities: "escuela superior",
    showPast: "Mostrar pasado",
    emptyList: "No hay tales materiales",
    show: "Mostrar",
    result1: "resultado",
    result2: "resultado",
    result5: "resultado",
    filters: "Filtros",
    clear: "Limpiar",
  },
};
